<div class="search_div open">
    <div id="navbar-search" class="navbar-form search-form">
        <span class="p-input-icon-right" style="display: block !important;">
            @if(searchControl?.value){
            <!-- <i (click)="searchControl.reset()" class="pi pi-times cursor-pointer"></i> -->
            }
            <input pInputText type="text" [formControl]="searchControl" class="w-100  "
                placeholder="{{'Search...' | titlecase}} "
                style="border-radius: 20px; padding-left: 16px; height: 37px;" />
            <i class="pi pi-search"></i>
        </span>
        <!-- <div class="search-container">
            <form>
                <input type="search" class="form-control rounded-pill" placeholder="Search..." id="top-search">
                <span class="pi pi-search search-icon font-22"></span>
            </form>
        </div> -->
    </div>
    <div class="form-group" [formGroup]="filterForm">
        <div class="row clearfix">
            @for (a of filterCol; track a) {
            <div class="col-md-3 col-lg-3">
                <select (change)="searchChange(searchControl)" class="custom-select" [formControlName]="a.tblName">
                    <option value="">{{a.tblName | titlecase}}</option>
                    @for (b of FORM_SUPPORT_DATA[a.tblName]; track b) {
                    <option [value]="b.id">{{b[a.colName || a.tblName+'Name']}}</option>
                    }
                </select>
            </div>
            }
        </div>
    </div>
    <span class="mb-1 text-muted ">Search Result <small class="float-end text-muted"> @if
            (loading) {
            <i class="pi pi-spin pi-spinner"></i>
            }
        </small></span>
    <div class="search_container">
        @if (!resultData?.length && !loading) {
        <div class="text-center" style="margin-top: 50%">
            No Result Found
        </div>
        }
        <div class="table-responsive" *ngIf="resultData?.length">

            <table class="table table-borderless table-hover table-nowrap table-centered m-0">
                <thead>
                    <ng-container *ngIf="data.type === 'Student'">
                        <tr>
                            <th scope="col">Profile</th>
                            <th scope="col">Student Name/Code</th>
                            <th scope="col">Father Name/Mobile No</th>
                            <th scope="col">School/Class</th>
                        </tr>
                    </ng-container>
                </thead>
                <thead>
                    <ng-container *ngIf="data.type === 'Staff'">
                        <tr>
                            <th scope="col">Profile</th>
                            <th scope="col">Staff Name/Staff Id</th>
                            <th scope="col">Mobile No/Email Id</th>
                            <th scope="col">Institution</th>
                        </tr>
                    </ng-container>
                </thead>
                <tbody>
                    @for (t of resultData; track t; let i = $index) {
                    <tr (click)="onConfirm(t)">
                        <td style="width: 36px;">
                            <img [src]="t?.avatarPic" imageLoad [alt]="t?.detail" class="rounded-circle avatar-sm">
                        </td>

                        <td>
                            <h5 class="m-0 fw-normal">{{t?.detail}}</h5>
                            <p class="mb-0 text-muted"><small>{{t?.mutedText}}</small></p>
                        </td>

                        <!-- <td>
                            <i class="mdi mdi-currency-btc text-primary"></i> 
                        </td>

                        <td>
                            
                        </td> -->
                        <!-- <div class="flex-grow-1 ms-3">
                            <span class="name" [innerHTML]="t?.detail"></span>
                            <span class="message" [innerHTML]="t?.mutedText"></span>
                            <span class="badge badge-outline status"></span>
                        </div> -->

                        <td>
                            @if (t?.topEndText) {
                            <span style="font-size: small;">
                                {{t?.topEndText}}
                            </span>
                            <p class="mb-0 text-muted"><small>{{t?.active}}</small></p>
                            }
                        </td>
                        <td>
                            @if (t?.bottomEndText || t?.bottomTopText) {
                            <span class="float-right" style="color: blue;">
                                <ng-container *ngIf="data.type === 'Staff'">
                                    School:{{t?.bottomEndText}}
                                </ng-container>
                                <ng-container *ngIf="data.type === 'Student'">
                                    School:{{t?.bottomTopText}}, &nbsp;{{t?.bottomEndText}}
                                </ng-container>
                            </span>
                            }
                        </td>

                        <!-- <td>
                            <a href="javascript: void(0);" class="btn btn-xs btn-light"><i class="mdi mdi-plus"></i></a>
                            <a href="javascript: void(0);" class="btn btn-xs btn-danger"><i
                                    class="mdi mdi-minus"></i></a>
                        </td> -->
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <ul class="right_chat list-unstyled mb-0">
            @for (t of resultData; track t; let i = $index) {
            <!-- <li [ngClass]="{'offline': t?.active , 'online' : !t?.active}" class="mb-1" (click)="onConfirm(t)">
                <a href="javascript:void(0);">
                    <div class="d-flex">
                        <div class="flex-shrink-0">
                            <img [src]="t?.avatarPic" imageLoad [alt]="t?.detail" class="w40 h35 rounded">
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <span class="name" [innerHTML]="t?.detail"></span>
                            <span class="message" [innerHTML]="t?.mutedText"></span>
                            <span class="badge badge-outline status"></span>
                        </div>
                        <div style="flex: 0;text-align: right;" class="text-muted">
                            @if (t?.topEndText) {
                            <span style="font-size: small;">
                                {{t?.topEndText}}
                            </span>
                            }
                            @if (t?.bottomEndText) {
                            <span class="float-right">
                                {{t?.bottomEndText}}
                            </span>
                            }
                        </div>
                    </div>
                </a>
            </li> -->
            }
        </ul>
    </div>
</div>